function delayAnimation(){

    let x = window.screen.width;

    function check_price_size(){
        product_price_block = Array.from(document.querySelectorAll(".product-block .block-inner .product-price"))
        product_title_block = Array.from(document.querySelectorAll(".product-block .block-inner .product-block__title"))
    
        let bigger_price = 0
        let bigger_price_string
    
        product_price_block.map((price_inner) =>{
            price_inner.style.height = "auto"
            price_inner.offsetHeight>bigger_price ? bigger_price = price_inner.offsetHeight : ''
        })
    
        bigger_price_string = bigger_price.toString() + 'px'
    
        product_title_block.map((block_title) =>{
            block_title.style.paddingBottom = bigger_price_string
        })
    }
    
    function check_inner_size(){
        array_product_block = Array.from(document.querySelectorAll(".product-block .block-inner .block-inner-inner"))
        let bigger_block = 0
        let bigger_block_string
    
        array_product_block.map((block_inner) =>{
            block_inner.style.height = "auto"
            block_inner.offsetHeight>bigger_block ? bigger_block = block_inner.offsetHeight : ''
        })
    
        bigger_block_string = bigger_block.toString() + 'px'
    
        array_product_block.map((block_inner) =>{
            block_inner.style.height = bigger_block_string
        })
    
    }
    
    document.addEventListener('theme:ajax:done', () => {
        check_price_size()
        check_inner_size()
    })


    window.onresize = function(){
        x = window.screen.width;
    
        check_price_size()
        check_inner_size()
    }
    
    check_price_size()
    check_inner_size()

};
delayAnimation()
$(window).on("load", setTimeout(delayAnimation, 1000));